import api, { IDataResponse, IDataRequest, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";

class ClientesProvider extends AProvider {
    constructor() {
        super("/cadastros/clientes");
    }

    async getCliente(clienteId: number): Promise<IDataResponse> {
        try {
            const filter = "usuario_id=" + clienteId;
            const includes = "includes=enderecos,cidade,pais&"

            const request: IDataRequest = {
                url: this.path + "/?" + includes + filter + "orderby=id",
            }

            const response: IDataResponse = await api.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data[0]
            }

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async getClienteListar(): Promise<IDataResponse> {
        try {
            const includes = "includes=enderecos,enderecos.cidade,enderecos.pais&"

            const request: IDataRequest = {
                url: this.path + "/listar?" + includes + "orderby=id",
            }
            const response: IDataResponse = await api.get(request);
            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async getClienteByDocumento(documento: string): Promise<IDataResponse> {
        try {
            const filter = "&documento=" + documento;
            const includes = "includes=enderecos,enderecos.cidade,enderecos.pais&"
            const request: IDataRequest = {
                url: this.path + "/listar?" + includes + filter + "&orderby=id",
            }

            const response: IDataResponse = await api.get(request);
            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async postCliente(cliente: any): Promise<IDataResponse> {
        try {
            const includes = "includes=enderecos,cidade,pais&"

            const request: IDataRequest = {
                url: this.path + "/?" + includes,
                data: cliente
            }

            const response: IDataResponse = await api.post(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async putCliente(cliente: any): Promise<IDataResponse> {
        try {
            const includes = "includes=enderecos,cidade,pais&"

            const request: IDataRequest = {
                url: this.path + "/" + cliente.id + "?" + includes,
                data: cliente
            }

            const response: IDataResponse = await api.put(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async postClienteWhatsapp(contato: string, pais: number): Promise<IDataResponse> {
        try {

            const request: IDataRequest = {
                url: this.path + "/whatsapp",
                data: {
                    contato: contato,
                    pais: pais
                }
            }

            const response: IDataResponse = await api.post(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async getClienteCRMByDocumento(documento: string): Promise<IDataResponse> {
        try {

            const request: IDataRequest = {
                url: this.path + "/buscar/crm/" + documento,
            }

            const response: IDataResponse = await api.post(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response
            }

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }
}

export const clientesProvider = new ClientesProvider();
export { ClientesProvider };